(function(){
  document.querySelectorAll('.t100parts[data-t100parts]').forEach(function(root){
    var params=new URLSearchParams(window.location.search);
    var wantedAssembly=params.get('assembly');
    var wantedGroup=params.get('group');
    if(!wantedAssembly) return;
    var parts=window.TJAT100Parts||[];
    if(!wantedGroup){var match=parts.find(function(p){return p.a===wantedAssembly;});if(match) wantedGroup=match.g;}
    var system=wantedGroup?root.querySelector('.t100parts__system[data-group="'+wantedGroup.replace(/"/g,'')+'"]'):null;
    if(system) system.click();
    window.setTimeout(function(){
      var select=root.querySelector('[data-t100-assembly]');
      if(!select) return;
      var exists=Array.prototype.some.call(select.options,function(opt){return opt.value===wantedAssembly;});
      if(!exists) return;
      select.value=wantedAssembly;
      select.dispatchEvent(new Event('change',{bubbles:true}));
      window.setTimeout(function(){var panel=root.querySelector('.t100parts__diagramPanel');if(panel) panel.scrollIntoView({block:'start'});},0);
    },0);
  });
})();
